import type { FPost, IChallenge } from 'garden-common';
import { writable } from 'svelte/store';

export const challengeStore = writable<IChallenge<string>[]>([]);
export const challengesLoading = writable(true);
export const challengePostsStore = writable<FPost<string>[]>([]);
